import { render, staticRenderFns } from "./BarChartFromCsv.vue?vue&type=template&id=64cbd685&scoped=true"
import script from "./BarChartFromCsv.vue?vue&type=script&lang=ts"
export * from "./BarChartFromCsv.vue?vue&type=script&lang=ts"
import style0 from "./BarChartFromCsv.vue?vue&type=style&index=0&id=64cbd685&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cbd685",
  null
  
)

export default component.exports